import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { SortProps, TableColumn, TableRow, TableVariant } from '../../types';
import { TableHeadSortableCell } from '../TableHeadSortableCell';
import { alignStyles, variantStyles } from './styles';

interface TableHeadCellProps<R extends TableRow> extends SortProps {
  cell: TableColumn<R>;
  variant: TableVariant;
  className?: string;
}

export const TableHeadCell = <R extends TableRow>({
  cell,
  variant,
  onSort,
  sorting,
  className,
}: TableHeadCellProps<R>): ReactElement => {
  return (
    <th
      scope="col"
      className={twMerge(
        'h-8 border-b-2.5 border-transparent bg-inherit px-2.5 text-xs font-black leading-xs',
        variantStyles[variant],
        cell.columnSeparator && 'with-divider',
        cell.className,
        className,
      )}
      colSpan={cell.colSpan}
    >
      <div
        className={twMerge(
          'relative inline-flex w-full items-center',
          alignStyles[cell.alignHeader || 'center'],
        )}
      >
        {cell.sortable ? (
          <TableHeadSortableCell
            cellId={cell.id}
            label={cell.label}
            onSort={onSort}
            sorting={sorting}
            variant={variant}
          />
        ) : (
          cell.label
        )}
      </div>
    </th>
  );
};
